export const B_TOK = {
  bg: '#fafafa',
  surface: '#ffffff',
  surfaceAlt: '#f7f7f8',
  border: '#e8e8eb',
  borderSoft: '#f0f0f2',
  borderStrong: '#d4d4d8',
  text: '#0a0a0b',
  textMute: '#6b7280',
  textSoft: '#a1a1aa',
  primary: '#0c1e3e',
  primaryDeep: '#091732',
  accent: '#0050d0',
  accentSoft: '#eef3fb',
  ok: '#15803d',
  okBg: '#f5faf6',
  okDot: '#16a34a',
  warn: '#92681c',
  warnBg: '#fcfaf3',
  warnDot: '#d97706',
  danger: '#b1170f',
  dangerBg: '#fcf5f5',
  dangerDot: '#dc2626',
  info: '#0369a1',
  infoBg: '#f3f8fc',
  font: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
  fontMono: '"JetBrains Mono", ui-monospace, monospace',
} as const;

export type BTok = typeof B_TOK;

export const ACCENT = '#2563eb';
